module.exports = __webpack_public_path__ + "img/f77cd37.jpg";